import { Box, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { loadSmplrJs } from "@smplrspace/smplr-loader";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import LoginCookieAuth from "../../components/api/LoginCookieAuth";
import Cookies from "js-cookie";
import SkySparkGrid from "../../components/api/SkySparkGrid";
import InfLoader from "../../components/infLoad";

const SmplrSpaceComponentLocation = () => {
    const { siteId } = useParams();
    const [smplr, setSmplr] = useState()
    const [showSpace, setShowSpace] = useState(false)
    const [spaceData, setSpaceData] = useState({})
    const [viewerReady, setViewerReady] = useState(false)
    const [polylines, setPolylines] = useState([])
    const [selectedRoute, setSelectedRoute] = useState(null)
    const [layerId, setLayerId] = useState(null)
    const spaceRef = useRef()

    // Get unique names from polylines
    const getUniqueNames = () => {
        const names = polylines.map(polyline => polyline.name);
        return [...new Set(names)];
    };

    // Update visibility of polylines by adjusting alpha
    const updatePolylineVisibility = (name) => {
        if (!spaceRef.current || !layerId) {
            console.log('Space ref or layer ID is null');
            return;
        }

        // If clicking the same route again, hide all
        if (selectedRoute === name) {
            setSelectedRoute(null);
            if (spaceRef.current.getDataLayer(layerId) !== undefined) {
                spaceRef.current.updateDataLayer({
                    id: layerId,
                    type: 'dotted-polyline',
                    data: [],  // Empty data to hide all
                    tooltip: (d) => `${d.name}`,
                    color: "#BF40BF",
                    alpha: 1,
                    diameter: 0.5,
                    gap: 2,
                    animation: "railway"
                });
            }
            return;
        }

        // Show only selected polylines
        const visiblePolylines = polylines.filter(polyline => polyline.name === name);

        if (spaceRef.current.getDataLayer(layerId) !== undefined) {
            spaceRef.current.updateDataLayer({
                id: layerId,
                type: 'dotted-polyline',
                data: visiblePolylines,
                tooltip: (d) => `${d.name}`,
                color: "#BF40BF",
                alpha: 1,
                diameter: 0.5,
                gap: 2,
                animation: "railway"
            });
        }

        setSelectedRoute(name);
    };

    // Load smplr module
    useEffect(() => {
        loadSmplrJs('EMS')
            .then((smplr) => {
            setSmplr(smplr)})
            .catch((error) => console.log(error))
    }, [])

    // Fetch and set space data
    useEffect(() => {
        // Authenticate user cookie
        LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async(authResponse) => {
            if(authResponse) {
                // Try to fetch space data
                const FetchSpaceData = async () => {
                    try {
                        const siteData = await SkySparkGrid(`inf_api_sites(@${siteId})`);
                        // If no site is returned dont show space
                        if(siteData['data']['rows'][0].length === 0) setShowSpace(false)
                        // Else set spacedata object
                        else if(siteData['data']['rows'][0]['infSiteSmplrSpaceId']) {
                            const selectedSite = siteData['data']['rows'][0]
                            setSpaceData(spaceData => ({
                                ...spaceData,
                                spaceId : selectedSite['infSiteSmplrSpaceId'],
                                spaceCameraPosition : selectedSite['infSiteSmplrSpaceCameraPosition'],
                                spaceRefreshRate : selectedSite['infSiteSmplrSpaceRefreshRate']
                            }))
                            setShowSpace(true)
                        }
                    } catch (error) {
                        setShowSpace(false)
                        console.error("Error fetching space data:", error);
                    }
                }
            FetchSpaceData()
            }
        })
    }, [siteId])

    // Set and start spaceviewer
    useEffect(() => {
        setViewerReady(false)
        // Clear space if space already exists
        if(spaceRef.current) spaceRef.current.remove()
        // When the smplrspace module has been loaded set space and start viewer
        if(smplr && showSpace) {
            spaceRef.current = new smplr.Space({
                spaceId: spaceData['spaceId'],
                clientToken: 'pub_3ee2a5233b354181a61c5e49691e7704',
                containerId: 'smplrviewer'
            })
            // Start the SmplrSpace viewer
            spaceRef.current.startViewer({
                preview: false,
                allowModeChange: true,
                onReady: () => {
                    console.log('Viewer ready')
                    setViewerReady(true)
                },
                onError: (e) => console.error('could not start viewer' + e),
                cameraPlacement: spaceData['spaceCameraPosition'],
                renderOptions: {
                    floorplan: {
                    render: true,
                    alpha: 1,
                    elevationInCm: 2
                    }
                }
            })
        }
    }, [smplr, spaceData, siteId, showSpace])

    useEffect(() => {
        const FetchAndWriteAssetMap = async () => {
            try {
                if(!viewerReady) return;
                // Fetch assetmap from skyspark
                let assetMap = await SkySparkGrid(`api_siteSmplrSpaceAssets(@${siteId})`);
                assetMap = assetMap['data']['rows']

                console.log(assetMap)

                // Add Polyline data to fetched asset map
                const mockRoute = require('../../mockdata/westland-route-mock.json');

                assetMap.push(mockRoute);

                assetMap.forEach(level => {
                    if (level.type === 'polygon' && spaceRef.current !== null && level.name === 'Gebouwinstalaties'){
                        if (spaceRef.current.getDataLayer(level.id) !== undefined) {
                            spaceRef.current.updateDataLayer({
                              id: level.id,
                              type: 'polygon',
                              data: level.assets,
                              tooltip: (d) => `${d.name}`,
                              color: "#BF40BF",
                              height: 3,
                              alpha: 0.7
                            })
                          } else {
                            spaceRef.current.addDataLayer({
                              id: level.id,
                              type: 'polygon',
                              data: level.assets,
                              tooltip: (d) => `${d.name}`,
                              color: "#BF40BF",
                              height: 3,
                              alpha: 0.7
                            })
                        }
                    } else if (level.type === 'polyline' && spaceRef.current !== null && level.name === 'Installatieroutes') {
                        setPolylines(level.assets || []);
                        setLayerId(level.id);
                        
                        if (spaceRef.current.getDataLayer(level.id) !== undefined) {
                            spaceRef.current.updateDataLayer({
                              id: level.id,
                              type: 'dotted-polyline',
                              data: [],  // Start with empty data (invisible)
                              tooltip: (d) => `${d.name}`,
                              color: "#BF40BF",
                              alpha: 1,
                              diameter: 3,
                              gap: 3,
                              animation: "railway"
                            })
                          } else {
                            spaceRef.current.addDataLayer({
                              id: level.id,
                              type: 'dotted-polyline',
                              data: [],  // Start with empty data (invisible)
                              tooltip: (d) => `${d.name}`,
                              color: "#BF40BF",
                              alpha: 1,
                              diameter: 3,
                              gap: 3,
                              animation: "railway"
                            })
                        }
                    }
                });
            } catch (error) {
                console.error("Error fetching asset map:", error);
            }
        }
        FetchAndWriteAssetMap();
    }, [viewerReady, siteId])

    return (
    <Box m="18px">
        {
            showSpace ? (
                <>
                    <FormControl sx={{ width:{xl:'250px', lg:'250px', md:'230px', sm:'200px', xs:'140px'}, mb: 2 }}>
                        <InputLabel shrink={true} sx={{color:'black'}} id="route-selector-label">Selecteer Route</InputLabel>
                        <Select
                            labelId='route-selector-label'
                            label='Selecteer Route'
                            value={selectedRoute || " "}
                            onChange={(event) => {
                                const value = event.target.value;
                                if (value === '') {
                                    // Clear selection
                                    if (selectedRoute) {
                                        updatePolylineVisibility(selectedRoute);
                                    }
                                } else {
                                    updatePolylineVisibility(value);
                                }
                            }}
                            sx={{ width: '100%', height: '30px', color: '#141414', fontFamily:'Source Sans Pro,sans-serif !important'}}
                        >
                            <MenuItem value="">
                                <em>Geen route</em>
                            </MenuItem>
                            {getUniqueNames().map((name, index) => (
                                <MenuItem key={index} value={name}>
                                    {name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Box sx={{ height: { xl: '85vh', lg: '70vh', md: '60vh' }, width: { xl: '100%' } }} id="smplrviewer"/>
                </>
            ) : (
                <Box sx={{width:'100%', height:{ xl: '700px', lg: '500px', md: '400px' }, display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <InfLoader/>
                </Box>
            )
        }
    </Box>
    );
}

export default SmplrSpaceComponentLocation;